import { CheckCircle2, CreditCard, Loader2 } from "lucide-react";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "./ui/dialog";
import { formatMoney as currency } from "../lib/money";

export const PostSignDepositDialog = ({ receipt, onClose, onPay, busy, error }) => (
  <Dialog open={!!receipt} onOpenChange={(open) => { if (!open && !busy) onClose(); }}>
    <DialogContent data-testid="post-sign-deposit-dialog"
      className="no-print w-[calc(100vw_-_2rem)] max-w-md rounded-xl bg-white text-slate-900 p-7 sm:p-9">
      <CheckCircle2 size={36} className="text-emerald-600" aria-hidden="true" />
      <DialogTitle className="text-lg font-bold pr-4">Your proposal is signed</DialogTitle>
      <DialogDescription className="text-sm text-slate-600 [overflow-wrap:anywhere]" data-testid="post-sign-option">
        {receipt?.selected_option_label}
      </DialogDescription>
      <p className="text-2xl font-bold text-slate-900 leading-snug" data-testid="post-sign-deposit-amount">
        Pay {currency(receipt?.deposit_amount || 0)} to secure your booking
      </p>
      <p className="text-sm text-slate-500">Your signed proposal is being saved. You can pay securely now or return later.</p>
      {error && <p role="alert" className="text-sm text-red-600" data-testid="post-sign-payment-error">{error}</p>}
      <button type="button" onClick={onPay} disabled={busy} data-testid="post-sign-pay-deposit"
        className="inline-flex w-full items-center justify-center gap-2 rounded-full bg-emerald-600 hover:bg-emerald-700 text-white px-5 py-3 font-semibold transition-colors disabled:opacity-60">
        {busy ? <Loader2 size={18} className="animate-spin" /> : <CreditCard size={18} />}
        {busy ? "Opening secure payment…" : `Pay ${currency(receipt?.deposit_amount || 0)}`}
      </button>
      <button type="button" onClick={onClose} disabled={busy} data-testid="post-sign-pay-later"
        className="py-2 text-sm font-semibold text-slate-600 hover:text-slate-900 disabled:opacity-60">I'll pay later</button>
    </DialogContent>
  </Dialog>
);